import React from "react";
import Icon from "../../components/UI/Icon/Icon";
import { NoSeatProductToTicket } from "../../helpers/ticketHelper.ts";

const ProductCard = ({
  product,
  canSelect,
  onObjectDeselected,
  onObjectSelected,
  currency,
  showAction,
  tickets = null
}) => {
  const count = tickets.filter(t => t.ticketTemplateId === product.ticketTemplateId).length;

  const handleSelect = (type) => {
    switch (type) {
      case "add":
        if (!canSelect) {
          return;
        }
        if (product.allowedToSell >= count + 1) {

          onObjectSelected(NoSeatProductToTicket(product));
        }
        break;
      case "remove":
        if (count > 0) {
          onObjectDeselected(NoSeatProductToTicket(product));
        }
        break;
      default:
        break;
    }
  };

  if (showAction && (!product.allowedToSell || !product.capacity)) {
    return (
      <div className="partizan-open-selling__select-section-ticket partizan-open-selling__select-section-ticket-unavailable">
        <p>{product.name}</p>
        <p>Sold out</p>
      </div>
    );
  };

  return (
    <div className="partizan-open-selling__select-section-ticket" style={{ display: 'flex', flexDirection: 'row' }}>
      {product.imgUrl && (
        <img src={product.imgUrl} className="partizan-open-selling__select-section-ticket-image" />
      )}
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '100%' }}>
        {showAction ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px' }}>
              <p className="partizan-open-selling__text-normal-small">
                {product.name}
              </p>
              <p className="partizan-open-selling__select-section-ticket-price">
                {product.price} {currency}
              </p>
            </div>
            <div style={{ display: 'flex', WebkitJustifyContent: 'end' }}>
              <div className="partizan-open-selling__select-section-ticket-count">
                <button disabled={count === 0} type="button" onClick={() => handleSelect("remove")}>
                  <Icon name="minus" />
                </button>
                <span className="partizan-open-selling__select-section-ticket-count">
                  {count}
                </span>
                <button type="button" onClick={() => handleSelect("add")}>
                  <Icon name="plus" />
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p className="partizan-open-selling__text-normal-small">
                {product.name}
              </p>
              <p className="partizan-open-selling__text-bold">
                {product.price} {currency}
              </p>
            </div>
            <div />
          </>
        )}
      </div>
    </div>
  );
};

export const TicketsPicker = ({
  ticketTemplates,
  showAction = true,
  canSelect = true,
  onObjectDeselected,
  onObjectSelected,
  currency,
  tickets,
}) => {
  return (
    <>
      {ticketTemplates.map((ticket) => (
        <ProductCard
          showAction={showAction}
          canSelect={canSelect}
          key={ticket.ticketTemplateId}
          product={ticket}
          onObjectDeselected={onObjectDeselected}
          onObjectSelected={onObjectSelected}
          currency={currency}
          tickets={tickets}
        />
      ))}
    </>
  );
};

export const ProductPicker = ({
  productDefinitions,
  showAction = true,
  canSelect = true,
  onObjectDeselected,
  onObjectSelected,
  currency,
}) => {
  return (
    <>
      {productDefinitions.map((product) => (
        <ProductCard
          showAction={showAction}
          canSelect={canSelect}
          key={product.Id}
          product={product}
          onObjectDeselected={onObjectDeselected}
          onObjectSelected={onObjectSelected}
          currency={currency}
        />
      ))}
    </>
  );
};
